import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function ArrowUp(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    d: "M23.5484 17.9484C22.9462 18.5505 21.9698 18.5505 21.3677 17.9484L12.1781 8.75875L2.98836 17.9484C2.38628 18.5505 1.4098 18.5505 0.807716 17.9484C0.205476 17.3462 0.205476 16.3698 0.807716 15.7677L11.0877 5.48771C11.6899 4.88552 12.6662 4.88552 13.2684 5.48771L23.5484 15.7677C24.1505 16.3699 24.1505 17.3462 23.5484 17.9484V17.9484Z"
  }));
}

export { ArrowUp };
//# sourceMappingURL=ArrowUp.js.map